module.exports = {
          srcSet: __webpack_public_path__ + "0c0adadd309fa3c5240d4341480611db-120.png"+" 120w",
          images:[ {path: __webpack_public_path__ + "0c0adadd309fa3c5240d4341480611db-120.png",width: 120,height: 92}],
          src: __webpack_public_path__ + "0c0adadd309fa3c5240d4341480611db-120.png",
          toString:function(){return __webpack_public_path__ + "0c0adadd309fa3c5240d4341480611db-120.png"},
          
          width: 120,
          height: 92
        }